module.exports = __webpack_public_path__ + "img/opera.8236c843.svg";